export default __webpack_public_path__ + "static/media/17955 - Harwoo.34f41e4b.jpeg";